export default {
      id: "icon--groups-fixed-small-usage",
      viewBox: "0 0 20 16",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--groups-fixed-small-usage",
      toString: function () {
        return this.url;
      }
    }